export default {
  data() {
    return {
      valuesObj: {
        default: {
          value: '',
          label: this.$t("message.RelevationFirst"),
          labelShort: this.$t("message.RelevationFirstShort")
        },
        popular: {
          value: 'popular',
          label: this.$t("message.PopularFirst"),
          labelShort: this.$t("message.PopularFirstShort")
        },
        new    : {
          value: 'new',
          label: this.$t("message.NewFirst"),
          labelShort: this.$t("message.NewFirstShort")
        },
        old    : {
          value: 'old',
          label: this.$t("message.OldFirst"),
          labelShort: this.$t("message.OldFirstShort")
        },
        upload: {
          value: 'upload',
          label: this.$t("message.UploadDate"),
          labelShort: this.$t("message.UploadDateShort")
        },
        uploadasc: {
          value: 'uploadasc',
          label: this.$t("message.UploadDateAsc"),
          labelShort: this.$t("message.UploadDateAscShort")
        },
        price  : {
          value: 'price',
          label: this.$t("message.ExpensiveFirst"),
          labelShort: this.$t("message.ExpensiveFirstShort")
        },
        low_price  : {
          value: 'low_price',
          label: this.$t("message.CheapFirst"),
          labelShort: this.$t("message.CheapFirstShort")
        },

        add: {
          value: '',//дефолтная сортировка для наборов работ
          label: this.$t("message.AddDate"),
          labelShort: this.$t("message.AddDateShort")
        },
        addasc: {
          value: 'addasc',
          label: this.$t("message.AddDateAsc"),
          labelShort: this.$t("message.AddDateAscShort")
        },
      },
      to_set_id: $('#app-wrapper').attr('set_id'),
    }
  },

  computed  : {
    values(){
      let res=[];

      if ( this.to_set_id>0 ){
        res=[
          this.valuesObj.add,
          this.valuesObj.addasc,
          this.valuesObj.popular,
          this.valuesObj.new,
          this.valuesObj.old,
        ];
      }
      else if (this.$store.getters.is_my_selected) {
        res=[
          this.valuesObj.upload,
          this.valuesObj.uploadasc,
          //this.valuesObj.default,
          this.valuesObj.popular,
          this.valuesObj.new,
          this.valuesObj.old,
        ];
      }
      else {
        res=[
          this.valuesObj.default,
          this.valuesObj.popular,
          this.valuesObj.new,
          this.valuesObj.old,
          this.valuesObj.upload,
          this.valuesObj.uploadasc,
        ];
      }

      if ( this.$store.getters.is_sale_selected ){
        res.push( this.valuesObj.price );
        res.push( this.valuesObj.low_price );
      }

      return res;
    },

    placeholder() {
      return this.$t("message.RelevationFirst")
    },
    sort: {
      get() {
        let value = this.$store.getters.filters.sort;
        if (value === undefined || !value) {
          value = this.values[0];
        } else {
          value = this.valuesObj[value]
        }

        return value
      },
      set(valueObj) {
        if(!valueObj) {
          return false
        }

        let value = valueObj.value

        if (value !== undefined) {
          this.$store.dispatch('setFilters', {'p':1, sort: value.toString(), scroll:false}).then(() => {});
        }
      },
    }
  },
  methods   : {}
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/filter/SortTypeMix.js
// module id = null
// module chunks = 